// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchHistory_wrapper__1MIVO","open":"SearchHistory_open__3lu-m","result":"SearchHistory_result__OWAfk"};